var installedModules = {};
var moduleToHandlerMapping = {
	2604: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8392: {
		getter: () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	3413: {
		getter: () => (__webpack_require__.e(788).then(() => (() => (__webpack_require__(2788))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.11",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	7125: {
		getter: () => (__webpack_require__.e(427).then(() => (() => (__webpack_require__(8427))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.10.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "kubra-ui-lib-auth",
	},
	378: {
		getter: () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(4676))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.6.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	382: {
		getter: () => (Promise.all([__webpack_require__.e(151), __webpack_require__.e(62), __webpack_require__.e(654)]).then(() => (() => (__webpack_require__(151))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.16.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "kubra-ui-lib-mfe",
	},
	2643: {
		getter: () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(1346))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.35.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "kubra-ux-forge",
	},
	5203: {
		getter: () => (Promise.all([__webpack_require__.e(97), __webpack_require__.e(880)]).then(() => (() => (__webpack_require__(3880))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.3.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@honeycombio/opentelemetry-web",
	},
	6170: {
		getter: () => (Promise.all([__webpack_require__.e(634), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(7814))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/react-fontawesome",
	},
	6386: {
		getter: () => (Promise.all([__webpack_require__.e(97), __webpack_require__.e(661)]).then(() => (() => (__webpack_require__(7661))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.40.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@opentelemetry/auto-instrumentations-web",
	},
	7965: {
		getter: () => (__webpack_require__.e(630).then(() => (() => (__webpack_require__(4511))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.0.12",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-error-boundary",
	},
	8910: {
		getter: () => (__webpack_require__.e(818).then(() => (() => (__webpack_require__(9818))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.22.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	634: {
		getter: () => (__webpack_require__.e(382).then(() => (() => (__webpack_require__(9382))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/fontawesome-svg-core",
	},
	9062: {
		getter: () => (__webpack_require__.e(291).then(() => (() => (__webpack_require__(3291))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "history",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"62": [
		9062
	],
	"74": [
		378,
		382,
		2643,
		5203,
		6170,
		6386,
		7965,
		8910
	],
	"125": [
		7125
	],
	"392": [
		8392
	],
	"413": [
		3413
	],
	"604": [
		2604
	],
	"634": [
		634
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}